import * as R from "ramda";

export const serializeError = (error: any) => {
  if (error?.response) {
    return R.mergeRight(R.pick(["code", "message"], error), {
      response: R.pick(["data", "status", "statusText"], error.response),
    });
  }
  return error?.toString();
};
